import { ApolloProvider } from '@apollo/client'
import App from 'components/App'
import { type ReactNode, useSyncExternalStore } from 'react'
import { Links, Meta, type MetaFunction, Outlet, Scripts } from 'react-router'
import { markHydrated } from 'utils/hydration'

const GOOGLE_ANALYTICS_KEY = import.meta.env.VITE_GOOGLE_ANALYTICS_KEY

export const meta: MetaFunction = () => [{ title: 'Défimédoc' }]

export const Layout = ({ children }: { children: ReactNode }) => (
  <html lang="fr">
    <head>
      <meta content="width=450"
        name="viewport"
      />
      <meta charSet="utf-8" />
      <link href="/favicon.ico"
        rel="shortcut icon"
      />
      <meta content="#000000"
        name="theme-color"
      />
      <link href="/manifest.json"
        rel="manifest"
      />
      <link href="https://use.typekit.net/cvz1ogp.css"
        rel="stylesheet"
      />
      <script async
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_KEY}`}
      />
      <script dangerouslySetInnerHTML={{
        __html: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GOOGLE_ANALYTICS_KEY}');
      ` }}
      />
      <Meta />
      <Links />
    </head>
    <body>
      {children}
      <Scripts />
      <noscript>You need to enable JavaScript to run this app.</noscript>
    </body>
  </html>
)

export const HydrateFallback = () => null

const subscribe = () => () => { }

const Root = () => {
  const hydrated = useSyncExternalStore(subscribe, () => true, () => false)
  if (hydrated) {
    markHydrated()
  }

  return (
    <App
      ApolloProvider={ApolloProvider}
      key={String(hydrated)}
      Router={Outlet}
    />
  )
}

export default Root
